export { HomeComponent } from './home/home.component';
export { WhoWeAreComponent } from './who-we-are/who-we-are.component';
export { AboutusComponent } from './about-us/about-us.component';
export { UnderwritingComponent } from './underwriting/underwriting.component';
export { ImmediateAnnuitiesComponent } from './immediate-annuities/immediate-annuities.component';
export { DoIQualifyComponent } from './do-i-qualify/do-i-qualify.component';
export { SpaFormComponent } from './spa-form/spa-form.component';
export { ResultComponent } from './result/result.component';
export { ApplyComponent } from './apply/apply.component';
export { SuccessComponent } from './success/success.component';